import { Box, Typography, styled } from '@mui/material';

export const OptionRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(3),
  width: '100%',
  padding: theme.spacing(1, 0)
}));

export const OptionText = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  minWidth: 0
});

export const OptionName = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  fontWeight: 500,
  overflowWrap: 'anywhere'
}));

export const OptionPerspective = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  flexShrink: 0
}));

/** The perspectives side by side in one thin pill, like the chips they turn into once picked. */
export const PerspectiveSwitch = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  flexShrink: 0,
  gap: theme.spacing(0.5),
  padding: theme.spacing(0.5),
  borderRadius: theme.spacing(4),
  border: `1px solid ${theme.vars.palette.outline.variant}`
}));

/** One perspective in the switch; the one it stands at filled, as the type chips mark the active one. */
export const PerspectiveSegment = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active'
})<{ active: boolean }>(({ theme, active }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(0.5, 2),
  borderRadius: theme.spacing(4),
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  color: active
    ? theme.vars.palette.secondary.onContainer
    : theme.palette.text.secondary,
  backgroundColor: active
    ? theme.vars.palette.secondary.container
    : 'transparent',
  '&:hover': active ? {} : { backgroundColor: theme.palette.action.hover }
}));
